export default __webpack_public_path__ + "static/headless-checkout-dcb1e8dcb2da2a0d9fcf2d5a4ff981b0.png";